import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useT } from "../features/UseT";
import "./RefundAndReturnPolicyScreen.css";

function RefundAndReturnPolicyScreen() {
  const t = useT();
  const lang = useSelector((s) => s.language.current);
  const [ppHtml, setPpHtml] = useState({});
  useEffect(() => {
    if (!lang) return;
    fetch(`/longtxt/refundandreturnpolicy.json`)
      .then((res) => res.json())
      .then((data) => setPpHtml(data))
      .catch(console.error);
  }, [lang]);
  return (
    <div className="RefundAndReturnPolicyScreen">
      <a href="/" className="Back">
        <span>{`<< ${t.sdb}`}</span>
      </a>
      <span className="RefundTitle">{ppHtml.title_en}</span>
      <span
        className="RefundAndReturnPolicy"
        dangerouslySetInnerHTML={{ __html: ppHtml.en }}
      />
    </div>
  );
}

export default RefundAndReturnPolicyScreen;
